import { Component, OnInit, ViewChild } from "@angular/core";
import {  MatHorizontalStepper } from "@angular/material";
import { IntegratedAdmissionWizardService } from "../service/integrated-admission-wizard.service";
import { StepperSelectionEvent } from "@angular/cdk/stepper";
import { IntegratedAdmissionPatientComponent } from "../integrated-admission-patient/integrated-admission-patient.component";

@Component({
  selector: "app-integrated-admission-wizard",
  templateUrl: "./integrated-admission-wizard.component.html",
  styleUrls: ["./integrated-admission-wizard.component.css"]
})
export class IntegratedAdmissionWizardComponent implements OnInit {

  @ViewChild("stepper", { static: false }) stepper: MatHorizontalStepper;

   @ViewChild("patient", { static: false }) patient: IntegratedAdmissionPatientComponent ;

  loading = false;

  constructor(private service: IntegratedAdmissionWizardService) {}

  async ngOnInit() {
    this.loading = true;
    await this.service.init();
    this.loading = false;
  }

  cancel() {
    this.service.cancel();
  }


}
